export const CLIENT_CONTACT_AI_MAP = {
  email_action: {
    aiText: "client.email_content",
    aiTooltip: "client.imrove_with_ai_tooltip_for_email",
    aiEnhancer: "client.email_enhancer",
  },
  message_action: {
    aiText: "client.message_content",
    aiTooltip: "client.improve_with_ai_tooltip_for_message",
    aiEnhancer: "client.message_enhancer",
  },
  text_action: {
    aiText: "client.text_content",
    aiTooltip: "client.improve_with_ai_tooltip_for_text",
    aiEnhancer: "client.text_enhancer",
  },
};
